module.exports = __webpack_public_path__ + "static/media/footer-logo.a9955ca3.svg";